const clampCrop = ({ x, y, width, height }) => ({
  x: Math.max(0, Math.min(1, x)),
  y: Math.max(0, Math.min(1, y)),
  width: Math.max(0, Math.min(1 - x, width)),
  height: Math.max(0, Math.min(1 - y, height)),
});

export const DEXA_VISUAL_CROPS = {
  composition: {
    scan: clampCrop({ x: 0.025, y: 0.17, width: 0.36, height: 0.41 }),
    bodyFatChart: clampCrop({ x: 0.445, y: 0.17, width: 0.48, height: 0.28 }),
  },
  wholeBodyBmd: {
    scan: clampCrop({ x: 0.075, y: 0.185, width: 0.29, height: 0.405 }),
    referenceChart: clampCrop({ x: 0.04, y: 0.61, width: 0.36, height: 0.27 }),
  },
  hip: {
    scan: clampCrop({ x: 0.035, y: 0.185, width: 0.38, height: 0.355 }),
    referenceChart: clampCrop({ x: 0.035, y: 0.605, width: 0.37, height: 0.27 }),
  },
  hipBilateral: {
    rightScan: clampCrop({ x: 0.005, y: 0.19, width: 0.21, height: 0.22 }),
    leftScan: clampCrop({ x: 0.22, y: 0.19, width: 0.21, height: 0.22 }),
    referenceChart: clampCrop({ x: 0.53, y: 0.18, width: 0.39, height: 0.22 }),
  },
  hipDetail: {
    rightScan: clampCrop({ x: 0.02, y: 0.43, width: 0.19, height: 0.2 }),
    rightChart: clampCrop({ x: 0.23, y: 0.43, width: 0.325, height: 0.2 }),
    leftScan: clampCrop({ x: 0.02, y: 0.67, width: 0.19, height: 0.2 }),
    leftChart: clampCrop({ x: 0.23, y: 0.675, width: 0.325, height: 0.2 }),
  },
  lumbar: {
    scan: clampCrop({ x: 0.045, y: 0.185, width: 0.36, height: 0.375 }),
    referenceChart: clampCrop({ x: 0.035, y: 0.605, width: 0.37, height: 0.27 }),
  },
  lumbarSummary: {
    scan: clampCrop({ x: 0.04, y: 0.19, width: 0.16, height: 0.2 }),
    referenceChart: clampCrop({ x: 0.25, y: 0.19, width: 0.28, height: 0.18 }),
  },
};

export function detectDexaPageRole(value) {
  const text = String(value ?? "");
  if (/Resultados de composici[oó]n corporal/i.test(text) && /[ií]ndices adiposos/i.test(text)) {
    return "composition";
  }
  if (/\bCuello\s*Izquierdo/i.test(text) && /\bTotal\s*Izquierdo/i.test(text) && /\bDerecho/i.test(text)) {
    return "hipBilateral";
  }
  if (/Scan Date:/i.test(text) && /\bCuello\b/i.test(text) && /Riesgo de fractura/i.test(text)) {
    return "hipDetail";
  }
  if (/Cadera\s+(izquierda|derecha)/i.test(text)) {
    return "hip";
  }
  if (/Scan Date:/i.test(text) && /\bL1\s*-\s*L4\b/i.test(text) && /DMO/i.test(text)) {
    return "lumbarSummary";
  }
  if (/sCMO/i.test(text)) {
    return "scmo";
  }
  if (/Columna\s+vertebral\s+lumbar/i.test(text) && /\bL1\b/i.test(text) && /\bL4\b/i.test(text)) {
    return "lumbar";
  }
  if (
    /Resumen de resultados DEXA/i.test(text)
    && /Cost\.\s*I/i.test(text)
    && /Colum\.\s*D/i.test(text)
    && /DMO/i.test(text)
  ) {
    return "wholeBodyBmd";
  }
  if (/Scan Date:/i.test(text) && /\bCuello\b/i.test(text) && /\bL1\s*-\s*L4\b/i.test(text)) {
    return "centralSummary";
  }
  if (
    /Resumen de resultados DEXA/i.test(text)
    && /Grasa\s+Masa/i.test(text)
    && /Inclinaci[oó]n\s+Masa/i.test(text)
  ) {
    return "compositionDetail";
  }
  return "other";
}

export function getDexaVisualCropSpecs(role) {
  return DEXA_VISUAL_CROPS[role] ?? {};
}
